import React, { useState, useEffect, useRef } from 'react';
import { Redirect, Link } from 'react-router-dom';
import { Accordion, AccordionItem, AccordionItemHeading, AccordionItemButton, AccordionItemPanel } from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';
import DataTable from 'react-data-table-component';
import Loader from '../../Loader/Loader';

import { reqGET } from '../../../Utils';
import { api_crud_base, api_crud_route, data_interface, endpoints } from './Config';
import { getTokenInfo } from './../../../UseToken';
import { language } from './Language';
import { color } from '../../WEBContent/Color';
import { id } from 'date-fns/locale';

export default function View(props) {

    const [dados, set_dados] = useState(data_interface);
    const [lang, set_lang] = useState('pt');
    const [isloading, setLoading] = useState(true);
    const [isRedirect, setRedirect] = useState(false);
    const [isEdit, setisEdit] = useState(false);
    const [editedData, setEditedData] = useState(dados);
    const [idEntidade, setIdEntidade] = useState('')

    const tableStyle = {
        width: '100%',
        borderCollapse: 'collapse',
        fontSize: '14px',
        color: color.cor1.hexa,
        boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
        borderRadius: '8px',
        overflow: 'hidden',
        backgroundColor: color.cor3.hexa,
        marginBottom: '20px',
    };

    const headerCellStyle = {
        padding: '12px 15px',
        textAlign: 'center',
        color: color.cor3.hexa,
        fontWeight: '600',
        borderBottom: '2px solid #ddd',
        backgroundColor: color.cor2.rgb,
        textTransform: 'uppercase',
    };

    const cellStyle = {
        borderBottom: `1px solid rgb(${color.cor3.rgb})`,
        textAlign: 'center',
        verticalAlign: 'middle',
        padding: '12px 15px',
        color: color.corCinza.hexa,
        lineHeight: '1.6',
        backgroundColor: color.cor3.hexa,
    };

    const tarefasCellStyle = {
        ...cellStyle,
        textAlign: 'left',
        fontWeight: '500',
    };

    const rowStyle = {
        backgroundColor: color.cor3.hexa,
        transition: 'background-color 0.3s ease',
        //cursor: 'pointer',
    };

    // Para Instanciar todo o Objecto 
    const fetchInfo = async (id) => {
        console.log("id da entidade que tamos a editar", id)
        setIdEntidade(id)
        await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id}`)
            .then(res => set_dados(res.data[0]))
            .catch(() => 404
                //  TODO: ENVIAR PÃ�GINA 404
                //  alert(error)); 
            );
    }

    const change_lang = (l) => {
        set_lang(l)
        window.location.reload()

        //console.log('language', localStorage.getItem('lang'))
        //console.log('localstorage', localStorage)
    }

    useEffect(() => {

        //set_lang('pt')
        //set_lang_id('1')

        //get_fact_legacy_info()
        //get_fact_legacy_info()

        if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            change_lang('pt')
        }
        else {
            set_lang(localStorage.getItem('lang'))
            console.log("estamos a alterar para", lang)
        }

        setLoading(false)

    }, [props])

    useEffect(() => {

        if (props.location.state !== undefined) {

            fetchInfo(props.location.state.item['id']).then(() => setLoading(false))
        }
        else {
            setLoading(false);
            setRedirect(true);
        }

    }, [props]);


    const toggleEditMode = () => {
        setisEdit(!isEdit);
        setEditedData(dados); // Reseta os dados editados caso cancele a edição
    };

    const formatPhoneNumber = (phoneNumber) => {
        if (!phoneNumber) return '';

        // Remove qualquer caractere não numérico
        const cleaned = phoneNumber.replace(/\D/g, '');


        if (cleaned.length < 9) return phoneNumber;


        const countryCode = cleaned.slice(0, 3); // Exemplo: 351

        const phoneNumberWithoutCode = cleaned.slice(3);


        const formattedPhone = phoneNumberWithoutCode.replace(/(\d{3})(?=\d)/g, '$1 ');


        return `+${countryCode} ${formattedPhone}`;
    };

    console.log('DADOS DA ENTIDADE: ', dados)

    return isRedirect ?
        <Redirect to={endpoints.list} replace />
        :
        isloading ?

            <Loader />

            :

            <div className="content d-flex flex-column flex-column-fluid">
                <div className="card-body border-top p-4">
                    <div className="row mb-4">
                        <div className="col-md-6 p-4 bg-white shadow-sm" style={{ borderRadius: "8px" }}>
                            <div className="d-flex flex-column align-items-center">
                                {dados.info?.foto?.[0]?.link ? (
                                    <img
                                        src={dados.info.foto[0].link}
                                        alt="Profile"
                                        style={{ width: "96px", height: "96px", borderRadius: "50%" }}
                                        className="mb-3"
                                    />
                                ) : (
                                    <i
                                        className="bi bi-people-fill mb-3"
                                        style={{ fontSize: "96px", color: color.corCinza.rgb }}
                                    ></i>
                                )}
                                <h2 className="h5 fw-bold mb-1">{dados.info?.name || 'N/A'}</h2>
                                <p className="text-muted">{dados.profile?.name || 'N/A'}</p>
                            </div>
                        </div>

                        <div className="col-md-6 p-4 bg-white shadow-sm" style={{ borderRadius: "8px" }}>
                            <div className="row gy-3">
                                <div className="col-12">
                                    <label className="form-label text-muted">{language[lang].email}</label>
                                    <p className="fw-semibold text-dark border-bottom pb-1">
                                        {dados.contacts?.[0]?.email || 'N/A'}
                                    </p>
                                </div>
                                <div className="col-12">
                                    <label className="form-label text-muted">{language[lang].tlf}</label>
                                    <p className="fw-semibold text-dark border-bottom pb-1">
                                        {formatPhoneNumber(dados.contacts?.[0]?.mobile_phone) || 'N/A'}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row mb-4">
                        <div className="col-md-12 p-4 bg-white shadow-sm" style={{ borderRadius: "8px" }}>
                            <h3 className="h5 fw-bold mb-4">{language[lang].detalhes_utilizador}</h3>

                            <div className="row gy-3 mb-3">
                                <div className="col-md-3">
                                    <label className="form-label text-muted">{language[lang].sexo}</label>
                                    <p className="fw-semibold text-dark border-bottom pb-1">
                                        {dados.info.sexo == 2
                                            ? language[lang].feminino
                                            : dados.info.sexo == 1
                                                ? language[lang].masculino
                                                : dados.info.sexo == 0
                                                    ? language[lang].outro
                                                    : 'N/A'}
                                    </p>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label text-muted">{language[lang].birthday}</label>
                                    <p className="fw-semibold text-dark border-bottom pb-1">
                                        {dados.info?.birthday || 'N/A'}
                                    </p>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label text-muted">{language[lang].habilitacao_literaria}</label>
                                    <p className="fw-semibold text-dark border-bottom pb-1">
                                        {
                                            dados.info.habilitacao_literaria == 0
                                                ? language[lang].ensino_basico
                                                : dados.info.habilitacao_literaria == 1
                                                    ? language[lang].ensino_secundario
                                                    : dados.info.habilitacao_literaria == 2
                                                        ? language[lang].licenciatura
                                                        : dados.info.habilitacao_literaria == 3
                                                            ? language[lang].mestrado
                                                            : dados.info.habilitacao_literaria == 4
                                                                ? language[lang].doutoramento
                                                                : dados.info.habilitacao_literaria == 5
                                                                    ? language[lang].pos_doutoramento
                                                                    : 'N/A'
                                        }
                                    </p>
                                </div>
                            </div>

                            <div className="row gy-3 mb-3">
                                <div className="col-md-3">
                                    <label className="form-label text-muted">{language[lang].country}</label>
                                    <p className="fw-semibold text-dark border-bottom pb-1">
                                        {dados.addresses?.[0]?.country || 'N/A'}
                                    </p>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label text-muted">{language[lang].district}</label>
                                    <p className="fw-semibold text-dark border-bottom pb-1">
                                        {dados.addresses?.[0]?.region || 'N/A'}
                                    </p>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label text-muted">{language[lang].city}</label>
                                    <p className="fw-semibold text-dark border-bottom pb-1">
                                        {dados.addresses?.[0]?.city || 'N/A'}
                                    </p>
                                </div>
                            </div>
                            
                            <div className="row gy-3 mb-3">
                                <div className="col-md-3">
                                    <label className="form-label text-muted">{language[lang].village}</label>
                                    <p className="fw-semibold text-dark border-bottom pb-1">
                                        {dados.addresses?.[0]?.village || 'N/A'}
                                    </p>
                                </div>                                
                                <div className="col-md-3">
                                    <label className="form-label text-muted">{language[lang].morada}</label>
                                    <p className="fw-semibold text-dark border-bottom pb-1">
                                        {dados.addresses?.[0]?.address_detail || 'N/A'}
                                    </p>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label text-muted">{language[lang].postal_code}</label>
                                    <p className="fw-semibold text-dark border-bottom pb-1">
                                        {dados.addresses?.[0]?.postal_code || 'N/A'}
                                    </p>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label text-muted">{language[lang].local}</label>
                                    <p className="fw-semibold text-dark border-bottom pb-1">
                                        {dados.addresses?.[0]?.localidade || 'N/A'}
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="row mb-4">
                        <div className="col">
                            {Array.isArray(dados.info?.departamento) && dados.info.departamento.length > 0 && (
                                <div className={"div-table"}>
                                    <h3 className="h5 fw-bold mb-4">{language[lang].departamentosEntidade}</h3>
                                    <table className="table interlocutores-list table-hover table-bordered align-middle">
                                        <thead className="text-center align-middle">
                                            <tr>
                                                <th className='p-3'>{language[lang].departamento}</th>
                                                <th className='p-3'>{language[lang].funcoes}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {dados.info.departamento.map((departamento) => (
                                                <tr key={departamento.id} style={rowStyle}>
                                                    <td>{departamento.name}</td>
                                                    <td>{departamento.software?.map((software, index) => (
                                                            <span key={software.id}>
                                                                {software.nome}
                                                                {index < departamento.software.length - 1 ? ", " : ""}
                                                            </span>
                                                        ))}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className={'dash-cards footer'}>
                    <nav className="navbar bottom-navbar navbar-light">
                        <div className="navbar-footer">
                            <ul className="navbar-nav float-left"></ul>
                            <ul className="navbar-nav float-right">
                                <li className={(getTokenInfo().profile === 'Cliente') ? 'd-none' : "nav-item" + ' ' + getTokenInfo().profile}>
                                    <Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
                                        <i className="bi bi-chevron-left me-2"></i>
                                        <span>{language[lang].back}</span>
                                    </Link>
                                </li>

                                <li className="nav-item">
                                    <button onClick={toggleEditMode} className="nav-link text-white">
                                        <Link to={{ state: { item: { id: idEntidade }, operation: 'edit' }, pathname: endpoints.regist }}>
                                            <i className="bi bi-pencil me-2 text-white"></i>
                                            <span className="text-white">{language[lang].edit}</span>
                                        </Link>
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </div>
            </div>

}